import Text from "../../../components/Text";
import { OnMouseOver } from "../../../layouts/SupportZone/constants";
import SpecialSupport from "../../../layouts/SupportZone/SpecialSupport";
import { MARGINS_BY_BLOCK_TYPE, TITLE_LEVEL_VARIANT } from "../../constants";
import type { TitleBlock, TitleLevel } from "../../schema/blocks/title";
import Editable from "../components/Editable";
import BlockOptionsPanel from "../options/BlockOptionsPanel";
import TitleOptions from "../options/TitleOptions";
import { handleLinearNavigation } from "../utilities/navigation";
import type { BlockEditorProps } from "./types";

export default function TitleBlockEditor(props: BlockEditorProps<TitleBlock>) {
    const { block, onChange, autoFocus, controls } = props;
    return (
        <SpecialSupport
            enabled={OnMouseOver}
            content={
                <BlockOptionsPanel onInsert={controls.insertBlock} onRemove={controls.removeBlock}>
                    <TitleOptions block={block} onChange={(next) => onChange(next)} />
                </BlockOptionsPanel>
            }
        >
            <div id={block.anchor ?? undefined} css={MARGINS_BY_BLOCK_TYPE[block.type]}>
                <Text variant={TITLE_LEVEL_VARIANT[block.level]}>
                    <Editable
                        mode="text"
                        value={block.text}
                        placeholder="Titre"
                        autoFocus={autoFocus}
                        onChange={(text) => onChange({ ...block, text })}
                        onEnter={controls.splitBlock}
                        onBackspace={() => {
                            if (block.level < 3) {
                                onChange({ ...block, level: (block.level + 1) as TitleLevel });
                                return;
                            }
                            onChange({
                                id: block.id,
                                type: "body",
                                html: plainTextToHtml(block.text),
                            });
                        }}
                        onKeyDown={(event) => {
                            if (handleLinearNavigation(event)) controls.closeOptions();
                        }}
                    />
                </Text>
            </div>
        </SpecialSupport>
    );
}

function plainTextToHtml(text: string): string {
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
